"use client";

import React from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { X } from "lucide-react";
import { Input } from "@/components/catalyst/input";

interface SearchProps {
  domain: string;
}

export default function Search({ domain }: SearchProps) {
  const searchParams = useSearchParams();
  const router = useRouter();

  // Get the current search value from URL - this is our single source of truth
  const searchValue = searchParams.get("search") || "";

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Update URL without causing navigation/re-render
    const newUrl = value
      ? `/${domain}?search=${encodeURIComponent(value)}`
      : `/${domain}`;

    window.history.replaceState(null, "", newUrl);
  };

  const clearInput = () => {
    router.push(`/${domain}`);
  };

  return (
    <div className="w-full items-start space-y-2">
      <div className="relative w-full">
        <Input
          type="search"
          placeholder="Filter by something specific..."
          defaultValue={searchValue}
          onChange={handleInputChange}
        />
        {searchValue && (
          <button
            onClick={clearInput}
            className="absolute top-1/2 right-2 -translate-y-1/2 rounded-full p-1 transition-colors hover:bg-neutral-100"
            aria-label="Clear search"
          >
            <X className="h-4 w-4 text-neutral-500" />
          </button>
        )}
      </div>
    </div>
  );
}
